<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;"><span
                class="text-muted fw-light">Business Profile /</span> Product Settings</h4>
        <div class="row">
            <div class="col-md-12">

                <mat-card class=" mb-5">
                    <mat-card-header class="mt-3 mb-4">
                        <mat-icon>settings</mat-icon> Product Settings
                    </mat-card-header>


                    <mat-card-content>
                        <div class="d-flex align-items-start align-items-sm-center">
                            <div class="col-md-12 col-lg-12">
                                <!-- <div class="nav-align-top mb-4">
                                    <ul class="nav nav-pills mb-3 nav-fill" role="tablist">

                                        <mat-list class="nav-item">
                                            <button mat-button color="primary" type="button" class="nav-link active"
                                                role="tab" data-bs-toggle="tab"
                                                data-bs-target="#navs-pills-justified-tablesuccess"
                                                aria-controls="navs-pills-justified-tablesuccess" aria-selected="true">
                                                <mat-icon class="nav-icon">person</mat-icon>Payment Link Settings
                                            </button>
                                        </mat-list>

                                        <mat-list class="nav-item">
                                            <button mat-button color="primary" type="button" class="nav-link" role="tab"
                                                data-bs-toggle="tab" data-bs-target="#navs-pills-justified-tablefail"
                                                aria-controls="navs-pills-justified-tablefail"
                                                aria-selected="false"><mat-icon
                                                    class="nav-icon">notifications</mat-icon>Notifications Settings
                                            </button>
                                        </mat-list>

                                        <mat-list class="nav-item">
                                            <button mat-button color="primary" type="button" class="nav-link" role="tab"
                                                data-bs-toggle="tab" data-bs-target="#navs-pills-justified-tablefail"
                                                aria-controls="navs-pills-justified-tablefail"
                                                aria-selected="false"><mat-icon class="nav-icon">link</mat-icon>
                                                Others Settings
                                            </button>
                                        </mat-list>
                                    </ul>
                                </div> -->

                                <hr class="my-0 mb-5" />
                                <form [formGroup]="productSettingForm" (ngSubmit)="onSubmit()">
                                    <!-- <mat-grid-list cols="2" rowHeight="150px">
                                        <mat-grid-tile> -->
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="adminControls">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Payment Link Expiration Days</mat-label>
                                                    <input type="number" matInput
                                                        formControlName="requestExpirationMinutes" required>
                                                    <mat-error *ngIf="submitted && forms.requestExpirationMinutes.errors"
                                                        class="invalid-feedback">
                                                        <div *ngIf="forms.requestExpirationMinutes.errors.required"> This
                                                            field is required </div>
                                                        <div *ngIf="forms.requestExpirationMinutes.hasError('invalidNumber')">
                                                            Invalid number. Please enter a number between 3 and 90.
                                                        </div>
                                                    </mat-error>

                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <!-- </mat-grid-tile> -->
                                        <!-- <mat-grid-tile> -->
                                        <div class="col-md-6">
                                            <div class="adminControls">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Disclaimer</mat-label>
                                                    <textarea matInput formControlName="paymentEntryVerbiage"
                                                        name="paymentEntryVerbiage" id="paymentEntryVerbiage" class="custom-textarea"
                                                        [ngClass]="{'is-invalid':submitted && forms.paymentEntryVerbiage.errors}"
                                                        required> </textarea>
                                                    <mat-error *ngIf="submitted && forms.paymentEntryVerbiage.errors"
                                                        class="invalid-feedback">
                                                        <div *ngIf="forms.paymentEntryVerbiage.errors.required"> This
                                                            field is required </div>
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <alert class="notification"></alert>
                                    <mat-card-actions class="mb-5">
                                        <button mat-raised-button type="submit" style="margin-left:40px;" class="button"
                                            [disabled]="isLoading">
                                            <span class="material-symbols-outlined" *ngIf="status==false">
                                                edit
                                            </span>
                                            <!-- <mat-icon class="icons" *ngIf="status==false">edit </mat-icon>  -->
                                            <mat-icon class="icons" *ngIf="status==true"
                                                style="margin-right: 30px;">save</mat-icon>
                                            {{status==false ? 'Edit' :'Save Changes' }}
                                        </button>
                                        <button mat-raised-button *ngIf="status" (click)="reset()" class="buttonReset">
                                            Cancel</button>
                                    </mat-card-actions>
                                </form>
                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</div>


<div id="loadingspinner" *ngIf="isLoading">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>